export default __webpack_public_path__ + "static/media/img1.05ea6a6c.jpg";